export default __webpack_public_path__ + "static/media/Dental-Labs.d1823e64.png";